'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fa_IR = require('../locale/fa_IR');

var _fa_IR2 = _interopRequireDefault(_fa_IR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _fa_IR2['default'];